import React, { useEffect, useState } from 'react';
import api from '../../api';

const ACCENT = '#C9A84C';

export default function ServiceSelect({ onSelect, services: propServices }) {
  const [services, setServices] = useState(propServices || []);
  const [loading, setLoading] = useState(!propServices || propServices.length === 0);

  useEffect(() => {
    if (propServices && propServices.length > 0) {
      setServices(propServices);
      setLoading(false);
      return;
    }
    api.get('/services').then(r => setServices(r.data)).finally(() => setLoading(false));
  }, [propServices]);

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '60px 0' }}>
      <div className="spinner" style={{ margin: '0 auto' }} />
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '6px' }}>
          Choose a Service
        </h2>
        <p style={{ color: '#888', fontSize: '13px' }}>
          All bookings are request-based. Christian will confirm personally.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {services.map((s, index) => (
          <button
            key={s.id}
            onClick={() => onSelect(s)}
            className="service-card card-stagger"
            style={{
              animationDelay: `${index * 0.08}s`,
              background: '#141414',
              border: '1px solid #222',
              borderRadius: '8px',
              padding: '20px 22px',
              textAlign: 'left',
              color: '#fff',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px',
              width: '100%',
            }}
          >
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 800, fontSize: '15px', letterSpacing: '0.01em' }}>{s.name}</span>
                {s.is_mobile && (
                  <span style={{
                    background: 'rgba(201,168,76,0.08)', color: ACCENT,
                    fontSize: '9px', fontWeight: 700, padding: '2px 7px', borderRadius: '2px',
                    border: '1px solid rgba(201,168,76,0.25)', textTransform: 'uppercase', letterSpacing: '0.08em',
                  }}>Mobile</span>
                )}
                {s.request_only && (
                  <span style={{
                    background: 'rgba(99,102,241,0.08)', color: '#a5b4fc',
                    fontSize: '9px', fontWeight: 700, padding: '2px 7px', borderRadius: '2px',
                    border: '1px solid rgba(99,102,241,0.2)', textTransform: 'uppercase', letterSpacing: '0.08em',
                  }}>Request Only</span>
                )}
              </div>
              <div style={{ color: '#555', fontSize: '12px' }}>
                {s.duration_minutes} min
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ color: ACCENT, fontWeight: 900, fontSize: '22px', lineHeight: 1, letterSpacing: '-0.02em' }}>
                {s.starting_price ? 'From ' : ''}${parseFloat(s.price).toFixed(0)}
              </div>
              {s.after_hours_price && (
                <div style={{ color: '#555', fontSize: '11px', marginTop: '4px' }}>
                  AH: ${parseFloat(s.after_hours_price).toFixed(0)}
                </div>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
